// In-memory access token store — never written to localStorage/sessionStorage.
// Module-level so apiFetch can read it without depending on React context.

let _token: string | null = null;

export const getToken = (): string | null => _token;
export const setToken = (t: string | null): void => { _token = t; };
